import { CommonCardContainer } from "components/DashboardCards/cardStyles";
import queryString from "query-string";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import styled from 'styled-components';
import { useDebouncedCallback } from "use-debounce";



import defaultLocationIcon from "../../../assets/img/icons/default-location-filled.svg";
import defaultHoverLocationIcon from "../../../assets/img/icons/default-location-new.svg";
import deleteIcon from "../../../assets/img/icons/delete_normal.svg";
import deleteWhiteIcon from "../../../assets/img/icons/delete_white.svg";
import editIcon from "../../../assets/img/icons/edit-2.svg";
import LocationIcon from "../../../assets/img/icons/location_icon.svg";
import PlusBlack from "../../../assets/img/icons/plus_black_2.svg";
import Plus from "../../../assets/img/icons/plus_primary.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import PricingPlan from "../../../components/PricingPlan";
import TaskActionTooltip from "../../../components/Tooltip/TaskActionTooltip";
import ThreeDotDropdown from "../../../components/DropdownStyle/ThreeDotDropdown";
import { BorderButtonWithIcon, ButtonIcon, ButtonTakingFullWidth, PrimaryButton, WhiteButton } from "../../../styledComponents/buttons";
import { AddClientContainer, AddClientContainerNew, LocationItem, LocationContent } from "../../../styledComponents/clients";
import { CardTitle, CommonFlex, CommonFlexIcon, CommonGrid, CommonImage, CommonText, Container, ContentHeader, FormAlert, InputField, InputLabel, InputWithLabelSection, PageTitle } from "../../../styledComponents/common";
import { RedStar } from "../../../styledComponents/members";
import { checkHtml, checkUrl, validateEmail } from "../../../utils/helper";
import { DataAndMapContainer } from "../../FieldServices/JobSites/jobSitesStyles";
import { IconButtonHolder } from "../../Jobs/tasksStyles";
import AddLocationModal from "../ClientDetails/AddLocationModal";
import DeleteClientLocationModal from "../ClientDetails/DeleteClientLocationModal";
import StaticTaskLocationModal from "../ClientDetails/StaticTaskLocationModal";


export const MapButton = styled.button`
  /* Frame 2087324781 */
  box-sizing: border-box;
  
  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  gap: 10px;
  
  width: 55px;
  height: 32px;
  
  background: #E9F0FE;
  border: 1px solid #B7CDFA;
  border-radius: 32px;
  

  
  /* Map */
  font-family: 'Mona Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */
  color: #353A46;
  
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #dbe6e4;
  }
`;



const EditClient = props => {
  const [clientId, setClientId] = useState(null);
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [officeLocation, setOfficeLocation] = useState("");
  const [saveErrors, setSaveErrors] = useState({});
  const [pricingPopup, setPricingPopup] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [action, setAction] = useState("add");
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [clientLocations, setClientLocations] = useState([]);
  const [hoveredId, setHoveredId] = useState(null);
  const [staticLocationModalOpen, setStaticLocationModalOpen] = useState(false);
  const [selectedStaticLocation, setSelectedStaticLocation] = useState(null);
  const [locationIndex, setLocationIndex] = useState(null);
  const [modalLocation, setModalLocation] = useState(false);
  const [toolTip, setToolTip] = useState(-1);
  const [selectIndex, setSelectIndex] = useState(-1);
  const customerInputRef = useRef(null);
  const { t } = useTranslation();

  console.log("clientLocations", clientLocations);

  //for input focus
  useEffect(() => {
    if (customerInputRef.current) {
      customerInputRef.current.focus();
    }
  }, [props.selectedOrganization, props.clientDetails]);

  useEffect(() => {
    if (props.selectedOrganization && props.selectedOrganization.id) {
      if (props.location.search) {
        const queryParsed = queryString.parse(props.location.search);
        let payload = {
          organization_id: props.selectedOrganization.id,
          client_id: queryParsed?.id,
        };
        setClientId(queryParsed?.id);
        props.getClientDetails(payload);
        props.getClientLocation(payload);
      }
    }
  }, [props.selectedOrganization]);

  useEffect(() => {
    if (props.clientLocationList?.length > 0) {
      setClientLocations(props.clientLocationList);
    } else {
      setClientLocations([]);
    }
  }, [props.clientLocationList]);

  useEffect(() => {
    if (props.selectedOrganization && props.selectedOrganization.id) {
      if (props.location.search) {
        const queryParsed = queryString.parse(props.location.search);
        let payload = {
          organization_id: props.selectedOrganization.id,
          client_id: queryParsed?.id,
        };
        props.getClientLocation(payload);
      }
    }
  }, [props.selectedOrganization]);

  // Refetch location list when default location is updated
  useEffect(() => {
    if (
      props.clientLocationCreateUpdateSuccess &&
      props.selectedOrganization &&
      props.selectedOrganization.id &&
      clientId
    ) {
      const payload = {
        organization_id: props.selectedOrganization.id,
        client_id: clientId,
      };
      props.getClientLocation(payload);
    }
  }, [props.clientLocationCreateUpdateSuccess]);

  // Refetch location list when a new location is added (to update default status of all locations)
  useEffect(() => {
    if (
      props.createdClientLocationInfo &&
      props.createdClientLocationInfo.id &&
      props.selectedOrganization &&
      props.selectedOrganization.id &&
      clientId
    ) {
      const payload = {
        organization_id: props.selectedOrganization.id,
        client_id: clientId,
      };
      props.getClientLocation(payload);
    }
  }, [props.createdClientLocationInfo]);

  useEffect(() => {
    if (props.clientDetails && props.clientDetails !== null) {
      setClientName(props.clientDetails.name);
      if (props.clientDetails.email) {
        setClientEmail(props.clientDetails.email);
      } else if (!props.clientDetails.email) {
        setClientEmail("");
      }
      if (props.clientDetails.phone_number) {
        setPhoneNumber(props.clientDetails.phone_number);
      } else if (!props.clientDetails.phone_number) {
        setPhoneNumber("");
      }
      if (props.clientDetails.office_location) {
        setOfficeLocation(props.clientDetails.office_location);
      } else if (!props.clientDetails.office_location) {
        setOfficeLocation("");
      }
    }
  }, [props.clientDetails]);

  const onClientNameChange = e => {
    const { value } = e.target;
    setClientName(value);
    if (saveErrors && saveErrors["clientName"]) {
      delete saveErrors["clientName"];
    }
  };
  const onEmailChange = e => {
    const { value } = e.target;
    setClientEmail(value);
    if (saveErrors && saveErrors["clientEmail"]) {
      delete saveErrors["clientEmail"];
    }
  };
  const onAddressChange = e => {
    const { value } = e.target;
    setOfficeLocation(value);
  };

  const toggle = () => setModalLocation(!modalLocation);

  const cancelFunction = () => {
    props.history.push("/user/customers");
  };

  const pricingPopupToggle = () => {
    setPricingPopup(!pricingPopup);
  };

  const debouncedClientLocationDelete = useDebouncedCallback(location_id => {
    if (
      props.selectedOrganization &&
      props.selectedOrganization.id &&
      props.clientDetails?.id
    ) {
      let payload = {
        organization_id: props.selectedOrganization.id,
        client_id: props.clientDetails.id,
        location_id: location_id,
      };
      props.deleteClientLocation(payload);

      setTimeout(() => {
        setModalLocation(false);
      }, 500);
    }
  }, 500);

  const handleClientLocationDelete = location_id => {
    debouncedClientLocationDelete(location_id);
  };

  const handleDefaultLocation = id => {
    const payload = {
      id: id,
      organizationID: props.selectedOrganization.id,
      client: clientId,
      default: true,
    };
    props.updateClientLocation(payload);
  };

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
    setAction("add");
  };

  const popupToggleUpdate = item => {
    setSelectedLocation(item);
    setAction("update");
    setPopupOpen(!popupOpen);
  };

  const onHoverChange = id => {
    setHoveredId(id);
  };

  const toolTipChange = (value, locationId) => {
    setToolTip(value);
    setSelectIndex(locationId);
  };

  const handleShowLocation = (location, index) => {
    setSelectedStaticLocation(location);
    setLocationIndex(index);

    setTimeout(() => {
      setStaticLocationModalOpen(true);
    }, 300);
  };

  const handleDeleteLocation = location => {
    setSelectedLocation(location);
    setModalLocation(true);
  };

  const handleSave = () => {
    if (checkError()) {
      if (props.selectedOrganization && props.selectedOrganization.id) {
        let payload = {
          organization_id: props.selectedOrganization.id,
          client_id: clientId,
          name: clientName,
          //phone_number: phoneNumber ? `${phoneNumber}` : null,
          phone_number: phoneNumber
            ? phoneNumber[0] === "+"
              ? `${phoneNumber}`
              : `+${phoneNumber}`
            : null,
          email: clientEmail ? clientEmail : null,
          // office_location: officeLocation ? officeLocation : null,
        };
        props.updateClient(payload);
        setTimeout(() => {
          props.history.push("/user/customers");
        }, 1200);
      }
    }
  };

  const checkError = () => {
    let saveErrors = {};
    let formIsValid = true;
    if (!clientName.trim()) {
      formIsValid = false;
      saveErrors["clientName"] = t("please_enter_customer_name");
    } else if (clientName.length > 256) {
      formIsValid = false;
      saveErrors["clientName"] = t(
        "please_enter_customer_name_within_256_characters",
      );
    } else if (checkUrl(clientName)) {
      formIsValid = false;
      saveErrors["clientName"] = t("client_name_can_not_contain_url");
    } else if (checkHtml(clientName)) {
      formIsValid = false;
      saveErrors["clientName"] = t("invalid_client_name");
    }
    if (!validateEmail(clientEmail)) {
      formIsValid = false;
      saveErrors["clientEmail"] = t("please_enter_a_valid_email_address");
    }
    setSaveErrors(saveErrors);
    return formIsValid;
  };

  return (
    <div className="content">
      <PricingPlan
        isOpen={pricingPopup}
        toggle={pricingPopupToggle}
        popupText="You don't have permission to this feature."
        popupTitle="Upgrade to Elite to access this feature"
        history={props.history}
        backRoute="/user/dashboard"
        onlyElite
      />
      {/* <PageTitle>{t("customers")}</PageTitle> */}
      <ContentHeader>
        <BackButtonComponent
          onClick={() => props.history.push("/user/customers")}
          subTitle={t("back_to_all_customers")}
        />
      </ContentHeader>
      <Container style={{ padding: `30px` }}>
        {props.isLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            <CardTitle>{t("edit_customer")}</CardTitle>
            <CommonGrid disableResponsive responsiveBreakpoint="780px" responsiveColumns="1fr" alignItem="flex-start" columns="35% 65%">
              <AddClientContainerNew>
                <InputWithLabelSection>
                  <InputLabel>
                    {t("customer_name")} <RedStar>*</RedStar>
                  </InputLabel>
                  <InputField
                    type="text"
                    placeholder={t("write_customer_name")}
                    ref={customerInputRef}
                    value={clientName}
                    onChange={e => onClientNameChange(e)}
                    error={
                      saveErrors &&
                      saveErrors["clientName"] &&
                      saveErrors["clientName"] !== undefined
                    }
                  />
                  {saveErrors &&
                    saveErrors["clientName"] &&
                    saveErrors["clientName"] !== undefined && (
                      <FormAlert margin="0 0 0 5px">
                        {saveErrors["clientName"]}
                      </FormAlert>
                    )}
                </InputWithLabelSection>
                <InputWithLabelSection>
                  <InputLabel>{t("email_address")}</InputLabel>
                  <InputField
                    type="text"
                    placeholder={t("write_email")}
                    value={clientEmail}
                    onChange={e => onEmailChange(e)}
                    error={
                      saveErrors &&
                      saveErrors["clientEmail"] &&
                      saveErrors["clientEmail"] !== undefined
                    }
                  />
                  {saveErrors &&
                    saveErrors["clientEmail"] &&
                    saveErrors["clientEmail"] !== undefined && (
                      <FormAlert margin="0 0 0 5px">
                        {saveErrors["clientEmail"]}
                      </FormAlert>
                    )}
                </InputWithLabelSection>

                <InputWithLabelSection>
                  <InputLabel>{t("phone_number")}</InputLabel>
                  <PhoneInput
                    enableSearch
                    country={"us"}
                    value={phoneNumber}
                    onChange={phone => setPhoneNumber(phone)}
                    inputClass="phone-number-input"
                    buttonClass="phone-number-flag-dropdown"
                  />
                </InputWithLabelSection>

                {/* <InputWithLabelSection>
                  <InputLabel>Office Location</InputLabel>
                  <InputField
                    type="text"
                    placeholder="Write official address..."
                    value={officeLocation}
                    onChange={(e) => onAddressChange(e)}
                  />
                </InputWithLabelSection> */}

                <CommonFlex disableResponsive gap="15px" margin="20px 0 0 0">
                  <WhiteButton type="cancel" onClick={() => cancelFunction()}>
                    {t("cancel")}
                  </WhiteButton>
                  <PrimaryButton
                    padding={props.clientUpdateLoading ? "0 15px" : "0 35px"}
                    onClick={
                      !props.clientUpdateLoading ? () => handleSave() : ""
                    }
                  >
                    {props.clientUpdateLoading ? (
                      <ButtonTextLoader loadingText="Saving" fontSize="13px" />
                    ) : (
                      t("update")
                    )}
                  </PrimaryButton>
                </CommonFlex>
              </AddClientContainerNew>
              <>
                <CommonCardContainer style={{  marginTop: "25px"}} bgColor="#EDF8FE">

                  <CommonText fontWeight="600" margin="0 0 15px 0">
                    Locations
                  </CommonText>
                  <CommonFlex disableResponsive direction="column"  gap="12px">
                  {clientLocations?.length > 0 ? (
                    clientLocations.map((location, index) => (
                      <LocationItem
                        key={index}
                        onMouseEnter={() => onHoverChange(location.id)}
                        onMouseLeave={() => onHoverChange(null)}
                        
                      >
                        <LocationContent>
                          <CommonImage src={LocationIcon} size="20px" />
                          <div>
                            <CommonText fontWeight="600" fontSize="14px">
                              {location.name}
                            </CommonText>
                            <CommonText fontSize="12px" color="#666">
                              {location.address}
                            </CommonText>
                          </div>
                        </LocationContent>
                        <CommonImage
                          src={location.default ?  defaultLocationIcon : defaultHoverLocationIcon}
                          cursor="pointer"
                          onClick={!location.default ? () => handleDefaultLocation(location.id) : undefined}
                          style={{cursor: location.default ? "default" : "pointer"}}
                        />
                        <MapButton
                          onClick={() => handleShowLocation(location, index)}
                        >
                          Map
                        </MapButton>
                        <ThreeDotDropdown
                          options={[
                            { label: t("edit_location"), action: "edit" },
                            { label: t("delete_location"), action: "delete" },
                          ]}
                          onSelect={(option) => {
                            if (option.action === "edit") {
                              popupToggleUpdate(location);
                            } else if (option.action === "delete") {
                              handleDeleteLocation(location);
                            }
                          }}
                        />
                      </LocationItem>
                    ))
                  ) : (
                    <LocationItem>
                      <LocationContent>
                        <CommonText fontSize="14px" color="#999">
                          No locations added
                        </CommonText>
                      </LocationContent>
                    </LocationItem>
                  )}
                  </CommonFlex>
                  <CommonFlex justifyContent="flex-start" margin="15px 0 0 0" width="100%">
                    <ButtonTakingFullWidth
                      borderRadius="8px"
                      margin="0"
                      borderColor="#2266EF"
                      onClick={() => popupToggle()}
                    >
                      <ButtonIcon src={Plus} alt="plus" />
                      {clientLocations && clientLocations.length >= 1
                        ? t("add_more_location")
                        : t("add_location")}
                    </ButtonTakingFullWidth>
                  </CommonFlex>
                </CommonCardContainer>
                {selectedLocation &&
                selectedLocation.name !== null &&
                selectedLocation.address !== null ? (
                  props.selectedOrganization && props.selectedOrganization.id ? (
                    <AddLocationModal
                      isOpen={popupOpen}
                      toggle={popupToggleUpdate}
                      addClientLocation={props.addClientLocation}
                      updateClientLocation={props.updateClientLocation}
                      addOrUpdateclientLocalMapLoading={
                        props.addOrUpdateclientLocalMapLoading
                      }
                      createdClientLocationInfo={props.createdClientLocationInfo}
                      clientLocationCreateUpdateSuccess={
                        props.clientLocationCreateUpdateSuccess
                      }
                      organization_id={props.selectedOrganization.id}
                      client_id={clientId}
                      action={action}
                      id={selectedLocation?.id}
                      name={selectedLocation.name}
                      address={selectedLocation.address}
                      radius={selectedLocation.radius}
                      latitude={selectedLocation.latitude}
                      longitude={selectedLocation.longitude}
                    />
                  ) : null
                ) : props.selectedOrganization && props.selectedOrganization.id ? (
                  <AddLocationModal
                    isOpen={popupOpen}
                    toggle={popupToggle}
                    addClientLocation={props.addClientLocation}
                    addOrUpdateclientLocalMapLoading={
                      props.addOrUpdateclientLocalMapLoading
                    }
                    createdClientLocationInfo={props.createdClientLocationInfo}
                    organization_id={props.selectedOrganization.id}
                    client_id={clientId}
                    action={action}
                  />
                ) : null}

                <StaticTaskLocationModal
                  isOpen={staticLocationModalOpen}
                  toggle={() => {
                    setStaticLocationModalOpen(false);
                    setSelectedStaticLocation(null);
                  }}
                  taskLocation={selectedStaticLocation}
                  locationIndex={locationIndex}
                />

                <DeleteClientLocationModal
                  id={selectedLocation?.id}
                  isOpen={modalLocation}
                  toggle={toggle}
                  handleDelete={handleClientLocationDelete}
                  isLoading={props.clientLocationDeleteLoading}
                />
              </>
            </CommonGrid>
          </>
        )}
      </Container>
    </div>
  );
};

export default EditClient;